import React, { useEffect, memo } from "react"
import { navigate } from "@reach/router"
import { useRedirectMetadata } from "../queries/useRedirectMetaData"
import Errorpage from "./errorpage"

const NotFoundPage = ({ data, location }) => {
  // old code
  const redirectData = useRedirectMetadata()

  const isBrowser = () => typeof window !== "undefined"
  let path = isBrowser() && window?.location?.href
  useEffect(() => {
    redirectData?.allWp?.edges?.map((it, ind) => {
      for (let index = 0; index < it?.node?.seo?.redirects.length; index++) {
        const element = it?.node?.seo?.redirects[index]
        if (path === `${window?.location?.origin}/${element?.origin}`) {
          isBrowser() &&
            window.location.replace(
              `${window?.location?.origin}/${element?.target}`,
              "_self"
            )
          break
        } else {
          navigate("/errorpage")
          isBrowser() && window.location.reload()
        }
      }
    })
  }, [path])
  // old code

  return (
    <>
      <Errorpage />
    </>
  )
}

export default memo(NotFoundPage)
